import { useMemo } from 'react';

import type { ColGroupDef } from 'ag-grid-enterprise';

import type { StateDistribution } from '@enterprise/api';

import NumberCellRenderer from '@components/grid/renderers/number-cell.renderer';
import TotalCellRenderer from '@components/grid/renderers/total-cell-renderer';

export const useGetStateDistributionColumns = () => {
  return useMemo(() => {
    return [
      {
        children: [
          {
            cellDataType: 'number',
            field: 'mailingId',
            headerClass: ['bg-blue-900'],
            headerName: 'ID',
            hide: true,
            width: 125,
          },
        ],
        headerClass: ['bg-blue-950'],
        headerName: 'Mailing Information',
      },
      {
        children: [
          {
            cellRenderer: TotalCellRenderer,
            field: 'stateAcronym',
            headerClass: ['bg-gray-900'],
            headerName: 'Abbreviation',
            width: 175,
          },
        ],
        headerClass: ['bg-gray-950'],
        headerGroupComponentParams: {
          icon: 'fa-flag-usa',
        },
        headerName: 'State',
      },
      {
        children: [
          {
            aggFunc: 'sum',
            cellClass: ['bg-green-300', 'text-green-900'],
            cellRenderer: NumberCellRenderer,
            field: 'quantity',
            filter: 'agNumberColumnFilter',
            headerClass: ['bg-green-800'],
            headerName: 'Recipients',
            type: ['numericColumn'],
            width: 175,
          },
        ],
        headerClass: ['bg-green-950'],
        headerGroupComponentParams: {
          icon: 'fa-circle-check',
        },
        headerName: 'Total',
      },
    ] as ColGroupDef<StateDistribution>[];
  }, []);
};
